import React from 'react';

interface SecurityDiagramProps {
    className?: string;
}

const SecurityDiagram: React.FC<SecurityDiagramProps> = ({ className = '' }) => {
    return (
        <div className={`w-full flex flex-col items-center gap-6 ${className}`}>
            {/* Shield icon */}
            <svg width="80" height="96" viewBox="0 0 80 96" fill="none">
                <path
                    d="M40 4L72 20V48C72 68 56 84 40 92C24 84 8 68 8 48V20L40 4Z"
                    stroke="rgba(255,255,255,0.4)"
                    strokeWidth="1.5"
                    fill="none"
                />
                {/* Lock icon inside shield */}
                <rect x="30" y="40" width="20" height="16" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5" rx="0" />
                <path
                    d="M34 40V34C34 30.7 36.7 28 40 28C43.3 28 46 30.7 46 34V40"
                    stroke="rgba(255,255,255,0.5)"
                    strokeWidth="1.5"
                    fill="none"
                />
                <circle cx="40" cy="48" r="2" fill="rgba(255,255,255,0.5)" />
            </svg>

            {/* Compliance badges */}
            <div className="flex items-center gap-4">
                {[
                    { label: 'HIPAA', sublabel: 'Compliant' },
                    { label: 'FERPA', sublabel: 'Compliant' },
                    { label: 'SOC 2', sublabel: 'Ready' },
                ].map((badge) => (
                    <div
                        key={badge.label}
                        className="border border-neutral-600 px-4 py-2 text-center"
                    >
                        <div className="text-sm font-bold text-white">{badge.label}</div>
                        <div className="text-[10px] text-gray-500 uppercase tracking-wider">{badge.sublabel}</div>
                    </div>
                ))}
            </div>

            {/* Encryption indicator */}
            <div className="flex items-center gap-2 text-gray-500 text-xs">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1" />
                    <path d="M4 7L6 9L10 5" stroke="currentColor" strokeWidth="1" />
                </svg>
                <span>AES-256 encryption at rest and in transit</span>
            </div>
        </div>
    );
};

export default SecurityDiagram;
